import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { SessionService } from '@core/services/session.service';
import { ToastrService } from 'ngx-toastr';

export const userGuard: CanActivateFn = () => {
  const router: Router = inject(Router);
  const sessionService = inject(SessionService);
  const toastService = inject(ToastrService);

  if (!!sessionService.profile()) {
    return true;
  } else {
    toastService.error('You must be logged in to access this page');
    router.navigate(['/']);
    return false;
  }
};
